let _history = null;

function setHistory(history) {
  _history = history;
}

function push(route) {
  _history.push(route);
}

export default {
  setHistory,
  push,
};
